module.exports = __webpack_public_path__ + "static/img/member_list_7.3be7b657.png";